


















































import VueOptions from '@utils/VueOptions'
import CalendarService from '@services/CalendarService'
import calendarPrototypes from './prototypes.json'

settings =
  name: 'AvailabilityHoursForm'

  vue:
    props: ['availabilityHours', 'calendar']

    data: ->
      selectedDay: null

    computed:
      events: -> @calendar.events
      seasons: -> @calendar.seasons
      dayOptions: -> CalendarService.dayOptionsForEvents(@events)

    beforeMount: ->
      @ensureGroupsForOptions()

    methods:
      hiInputChanged: ->
        @rerender()

      hiAddTimeWindow: (day) ->
        @addTimeWindow day

      hiRemoveTimeWindow: (day, timeWindow) ->
        @removeTimeWindow day, timeWindow

      syncTimeWindowsAllDay: (checked, day) ->
        timeWindows = @availabilityHours[day]
        timeWindow = timeWindows[0]
        timeWindow.all_day = checked

        if checked
          timeWindow.starts = '00:00'
          timeWindow.ends = '23:59'
          @availabilityHours[day] = [timeWindow]

        @rerender()

      addTimeWindow: (day) ->
        timeWindows = @availabilityHours[day]
        timeWindows.push { ...timeWindows[0] }
        @rerender()

      removeTimeWindow: (day, timeWindow) ->
        group = @availabilityHours[day]
        @availabilityHours[day] = group.filter((item) -> item isnt timeWindow) if group.length > 1
        @rerender()

      ensureGroupsForOptions: ->
        days = @dayOptions.map((option) -> option.value).filter((day) => !@availabilityHours[day])
        for day in days
          timeWindow = @createTimeWindowPrototype()
          if CalendarService.WEEKDAYS[day]
            timeWindow.weekday = day
          else
            timeWindow.day_of_month ||= day
          @availabilityHours[day] ||= [timeWindow]
        @rerender()

      createTimeWindowPrototype: ->
        # { ...calendarPrototypes.audience_availability.availability_hours[0] }
        {
          weekday: null,
          day_of_month: null,
          starts: '08:00',
          ends: '20:00',
          reach: null,
          all_day: false,
        }

      formatDay: (day) ->
        @dayOptions.find((option) -> option.value is day).label

export default VueOptions.vue settings
